import { cn } from "@/lib/utils";
import { MinusIcon, PlusIcon } from "@ngg/icons";
import type { ChangeEvent, InputHTMLAttributes, ReactNode } from "react";
import React from "react";

export interface QuantityProps extends InputHTMLAttributes<HTMLInputElement> {
  dense?: boolean;
  value: number;
  disabled?: boolean;
  onDecrease?: React.MouseEventHandler<HTMLButtonElement>;
  onIncrease?: React.MouseEventHandler<HTMLButtonElement>;
  onBlur?: (e: ChangeEvent<HTMLInputElement>) => void;
  DecreaseIcon?: ReactNode;
  IncreaseIcon?: ReactNode;
  classNames?: {
    wrapper?: string;
    increaseButton?: string;
    decreaseButton?: string;
    input?: string;
  };
}

export const Quantity = ({
  value,
  dense = false,
  disabled = false,
  onDecrease,
  onIncrease,
  onBlur,
  onChange,
  DecreaseIcon = <MinusIcon className="mx-2 h-4 w-4" />,
  IncreaseIcon = <PlusIcon className="mx-2 h-4 w-4" />,
  classNames,
  ...rest
}: QuantityProps) => (
  <div
    className={cn(
      "color-black flex border border-black bg-white",
      dense ? "h-8" : "h-12",
      disabled ? "pointer-events-none opacity-50" : "",
      classNames?.wrapper,
    )}
  >
    <button
      aria-label="decreaseButton"
      type="button"
      className={cn(
        "flex-shrink-0 basis-7 bg-white transition hover:opacity-75",
        classNames?.decreaseButton,
      )}
      onClick={onDecrease}
    >
      {DecreaseIcon}
    </button>

    <input
      {...rest}
      type="number"
      className={cn("w-full text-center text-base", classNames?.input)}
      value={value || ""}
      onChange={onChange}
      onBlur={onBlur}
    />

    <button
      type="button"
      className={cn(
        "flex-shrink-0 basis-7 bg-white transition hover:opacity-75",
        classNames?.increaseButton,
      )}
      aria-label="increaseButton"
      onClick={onIncrease}
    >
      {IncreaseIcon}
    </button>
  </div>
);
